import type { ScreenModule } from "../../../app/screen-module";
import { UsagePage } from "../SettingsPages";

export default {
	id: "end-user.usage",
	path: "/app/usage",
	area: "end-user",
	navGroup: "自分の設定",
	label: "利用状況",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: UsagePage,
} satisfies ScreenModule;
